import { useContext, useCallback, useEffect } from "react";
import { useNavigate } from "react-router";
import { useProperty } from "../../utils/context/PropertyProvider";
import Link from "./Link";
import { PaymentService } from "@propertelligent/client-api";
import Context, { PlaidAccountDetails } from "./Context";

export interface AddPlaidAccountProps {
  /** Called when Plaid link succeeds and payment method is saved (or details are ready) */
  onPlaidSuccess?: (plaidData: PlaidAccountDetails) => void;
  /** Show "Finish" button after successful link (e.g. first-time flow) */
  showFinishButton?: boolean;
}

const AddPlaidAccount = ({ onPlaidSuccess, showFinishButton = true }: AddPlaidAccountProps) => {
  const {
    linkSuccess,
    isItemAccess,
    dispatch,
    plaidAccountDetails,
  } = useContext(Context);


  // Call onPlaidSuccess callback when plaid link is successful
  useEffect(() => {
    if (linkSuccess && isItemAccess && plaidAccountDetails && onPlaidSuccess) {
      onPlaidSuccess(plaidAccountDetails);
    }
  }, [linkSuccess, isItemAccess, plaidAccountDetails, onPlaidSuccess]);

  
  const generateToken = useCallback(async () => {
    try {
     
      const data = await PaymentService.getApiPaymentMethodPlaidPaymentMethodCreateLinkToken();
      // const data = await PlaidAccountService.postApiPlaidAccountCreateLinkToken();

      if (data?.error) {
        dispatch({
          type: "SET_STATE",
          state: {
            linkToken: null,
            linkTokenError: data.error,
          },
        });
        return;
      }

      dispatch({
        type: "SET_STATE",
        state: {
          linkToken: data.link_token,
        },
      });

      localStorage.setItem("link_token", data.link_token);
    } catch (error) {
      console.error("Error generating link token:", error);
      dispatch({
        type: "SET_STATE",
        state: { linkToken: null },
      });
    }
  }, [dispatch]);

  /* ------------------ INIT ------------------ */
  useEffect(() => {
    const init = async () => {
      // await getInfo();

      if (window.location.href.includes("?oauth_state_id=")) {
        dispatch({
          type: "SET_STATE",
          state: {
            linkToken: localStorage.getItem("link_token"),
          },
        });
        return;
      }

      await generateToken();
    };

    init();
  }, [
    // getInfo,
     generateToken, dispatch]);

  /* ------------------ UI ------------------ */
  return (
    <Link />
  );
};

export default AddPlaidAccount;

